<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>渠道列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">渠道列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm2">
            <el-row :gutter="20">
              <!-- <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm2.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item label="来源渠道" prop="val1">
                  <el-select
                    v-model="ruleForm2.val1"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                  >
                    <el-option
                      v-for="(item, index) in sourseList"
                      :key="index"
                      :label="item.key"
                      :value="item.val"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="来源状态" prop="val2">
                  <el-select
                    v-model="ruleForm2.val2"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange"
                  >
                    <el-option
                      v-for="(item, index) in newCity"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户类型" prop="val3">
                  <el-select
                    v-model="ruleForm2.val3"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange"
                  >
                    <el-option
                      v-for="(item, index) in newCity"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="所属省" prop="val4">
                  <el-select
                    v-model="ruleForm2.val4"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange"
                  >
                    <el-option
                      v-for="(item, index) in newCity"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属市"
                  prop="val5"
                  style="margin-left: 20px"
                >
                  <el-select
                    v-model="ruleForm2.val5"
                    placeholder="请选择"
                    style="margin-right: auto; width: 150px"
                    @change="newcityChange1"
                  >
                    <el-option
                      v-for="(item, index) in newCity1"
                      :key="item.areaCode"
                      :label="item.name"
                      :value="item.areaCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm2.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm2.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="orgList" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="equipmentKey" label="设备码" align="center">
          </el-table-column>
          <el-table-column prop="sourceFrom" label="来源渠道" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceFrom == 1">咖德</span>
              <span v-if="scope.row.sourceFrom == 2">西安</span>
              <span v-if="scope.row.sourceFrom == 3">微博</span>
              <span v-if="scope.row.sourceFrom == 4">微信/公众号</span>
              <span v-if="scope.row.sourceFrom == 5">小红书</span>
              <span v-if="scope.row.sourceFrom == 6">抖音</span>
            </template>
          </el-table-column>
          <el-table-column prop="terminalType" label="App端" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.terminalType == 1">客户端</span>
              <span v-if="scope.row.terminalType == 2">保安端</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="人员类型" align="center">
          </el-table-column>
          <el-table-column prop="gmtCreate" label="创建时间" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
    Template,
  },
  data() {
    return {
      leftList: this.Plugins.askariData(),
      page: 1,
      pageSize: 10,
      total: 0,
      ruleForm2: {
        phone: "",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
        time: "",
        time1: "",
      },
      sourseList: [
        { val: 1, key: "咖德" },
        { val: 2, key: "西安" },
        { val: 3, key: "微博" },
        { val: 4, key: "微信/公众号" },
        // { val: 5, key: "小红书" },
        { val: 6, key: "抖音" },
      ],
      orgList: [],
    };
  },
  mounted() {
    // this.getcityList();
    this.getList();
  },
  methods: {
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        sourceFrom: this.ruleForm2.val1,
        startTime: this.ruleForm2.time,
        endTime: this.ruleForm2.time1,
      };
      this.$axios
        .post(`/admapi/bodyguard/pagestatistic`, param)
        .then(({ data }) => {
          this.orgList = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    getcityList() {
      let param = {
        areaCode: this.areaCode,
        levelCode: this.levelCode,
      };
      this.$axios
        .post(`/admapi/district/list`, param)
        .then(({ data }) => {
          if (this.levelCode == 1) {
            this.newCity = data;
          } else if (this.levelCode == 2) {
            this.newCity1 = data;
          } else if (this.levelCode == 3) {
            this.newCity2 = data;
          } else if (this.levelCode == 4) {
            this.newCity3 = data;
          }
        })
        .catch()
        .finally();
    },
    resetForm() {
      this.ruleForm2.val1 = "";
      this.ruleForm2.val2 = "";
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.ruleForm2.phone = "";
      this.ruleForm2.time = "";
      this.ruleForm2.time1 = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped></style>
